import { render, staticRenderFns } from "./CustomerImportModal.vue?vue&type=template&id=832aaeac&scoped=true&"
import script from "./CustomerImportModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportModal.vue?vue&type=style&index=0&id=832aaeac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832aaeac",
  null
  
)

export default component.exports